import { RecursivePartial } from '../types/types';
import { DefaultMessages, SegmentSpecificMessages, ProgramThemeMessages } from '@sheerid/jslib';

type LibraryMessages = DefaultMessages & SegmentSpecificMessages & ProgramThemeMessages;

/**
 * Feel free to modify this type for this project (only) here
 * For example, if you add a whole new block of text that the jslib does not have a spot for already
 *
 * This is not necessary if you are just overriding text for a pre-existing message id
 */
type ThisProjectMessages = {
    needHelp: string,
    optIn: string,
    step: {
        success: {
            toRedeemTitle: string,
            toRedeem1: string,
            toRedeem2: string,
        },
    },
};

export const medicalMessages: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    birthDate: 'Date of birth',
    emailAddress: 'Email address',
    firstName: 'First name',
    howDoesReviewWork: 'How does review work?',
    howDoesVerifyingWork: 'How does verifying work?',
    lastName: 'Last name',
    infoShared1: 'Information entered here will be used for verification purposes and shared with The North Face.',
    infoShared2: ' ',
    postalCode: 'Postal code',
    poweredBy: 'Verification services powered by SheerID',
    verifyAndContinue: 'Verify and continue',
    verificationPurposesOnly: 'Used for verification purposes only',
    verifyMyMedicalProfessionalStatus: 'VERIFY MY HEALTHCARE WORKER STATUS',
    needHelp: 'Need help?',
    optIn: "The North Face® uses SheerID to verify your eligibility, as described in the <a href='{sheerIdFaq}' class='sid-link' target='_blank' rel='noopener noreferrer'>SheerID FAQs</a>. When you provide your personal information directly to SheerID using this form, SheerID will attempt to verify your eligibility, but may need to ask you for additional information or documentation. SheerID will only use your personal information to verify your eligibility. SheerID will share your personal Information with The North Face® and The North Face® may use your personal information for additional purposes, including to send you marketing communication, as described in <a href='{privacyLink}' class='sid-link' target='_blank' rel='noopener noreferrer'>The North Face® Privacy Statement</a>. By checking this box and clicking the button labelled “VERIFY MY HEALTHCARE WORKER STATUS” above, you agree to the program <a href='{termsConditionsLink}' class='sid-link' target='_blank' rel='noopener noreferrer'>Terms and Conditions</a> and The North Face® Privacy Statement, and you consent to receive marketing communications from The North Face® by e-mail.",
    step: {
        personalInfo: {
            title: 'HEALTHCARE WORKERS DISCOUNT<br>UNLOCK THIS HEALTHCARE WORKERS-ONLY OFFER',
            subtitle: 'Verify you\'re a healthcare worker',
        },
        docUpload: {
            acceptedTypes: 'File must be .jpg .png .pdf .gif or .bmp',
            title: 'WE NEED MORE INFORMATION',
            cancelButtonLabel: 'CANCEL',
            submitButtonLabel: 'SUBMIT',
            uploadInstructions: 'Upload your government-issued document that shows:',
        },
        pending: {
            titleReview: 'PROCESSING',
            subtitle2: 'Wait here or let us notify you of the outcome. <br>You will be contacted via email.',
            subtitle3: 'Information entered into this web form will be used for verification purposes. The information will be shared with The North Face.',
        },
        success: {
            title: 'SUCCESS! YOU\'VE BEEN VERIFIED!',
            subtitle: 'Here is your Promo Code:',
            toRedeemTitle: 'To redeem:',
            toRedeem1: 'Click the "Apply a Promo Code" link listed directly below your Shopping Cart. Note: Your code must be applied BEFORE checkout and can only be used once.',
            toRedeem2: 'Enter your Promo Code.',
            redirectButtonText: 'CONTINUE',
            emailNotification: 'We have emailed you a copy so you can use your new code now or later. Look for an email from verify@sheerid.com',
            verificationOnly: 'SheerID handles verification only. Now that you\'ve been approved, please direct all questions about the promotion terms and/or code use to The North Face customer service',
        },
    },
};
